export type DscpItem = {
  name: string;
  value: number;
  valueBin: number;
};

export function dscp(): DscpItem[] {
  return [
    { value: 0, valueBin: 0b0, name: 'cs0' },
    { value: 0, valueBin: 0, name: 'default' },
    { value: 0, valueBin: 0, name: 'be' },
    { value: 8, valueBin: 0b1000, name: 'cs1' },
    { value: 16, valueBin: 0b10000, name: 'cs2' },
    { value: 24, valueBin: 0b11000, name: 'cs3' },
    { value: 32, valueBin: 0b100000, name: 'cs4' },
    { value: 40, valueBin: 0b101000, name: 'cs5' },
    { value: 48, valueBin: 0b110000, name: 'cs6' },
    { value: 56, valueBin: 0b111000, name: 'cs7' },
    { value: 10, valueBin: 0b1010, name: 'af11' },
    { value: 12, valueBin: 0b1100, name: 'af12' },
    { value: 14, valueBin: 0b1110, name: 'af13' },
    { value: 18, valueBin: 0b10010, name: 'af21' },
    { value: 20, valueBin: 0b10100, name: 'af22' },
    { value: 22, valueBin: 0b10110, name: 'af23' },
    { value: 26, valueBin: 0b11010, name: 'af31' },
    { value: 28, valueBin: 0b11100, name: 'af32' },
    { value: 30, valueBin: 0b11110, name: 'af33' },
    { value: 34, valueBin: 0b100010, name: 'af41' },
    { value: 36, valueBin: 0b100100, name: 'af42' },
    { value: 38, valueBin: 0b100110, name: 'af43' },
    { value: 46, valueBin: 0b101110, name: 'ef' },
    { value: 44, valueBin: 0b101100, name: 'voice-admit' },
  ];
}
